import { useTranslation } from 'react-i18next'
import { testimonials } from '@/mocks/site'

export default function TestimonialsSection() {
  const { t } = useTranslation()

  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('testimonials.label')}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('testimonials.title')}
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 text-primary-500">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill text-lg" />
              ))}
            </div>
            <span className="text-sm text-foreground-600">{t('testimonials.rating')}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8"
            >
              <div className="flex items-center justify-between mb-5">
                <i className="ri-double-quotes-l text-primary-400 text-3xl" />
                <div className="flex items-center gap-1 text-primary-500">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
              </div>
              <p className="font-heading italic text-lg md:text-xl text-foreground-800 leading-relaxed">
                {t(`testimonials.items.${item.id}.quote`)}
              </p>
              <div className="mt-6 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full flex items-center justify-center bg-accent-100 text-accent-700 font-heading text-lg font-semibold">
                  {t(`testimonials.items.${item.id}.name`).charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">
                    {t(`testimonials.items.${item.id}.name`)}
                  </span>
                  <span className="block text-xs text-foreground-500">
                    {t(`testimonials.items.${item.id}.role`)}
                  </span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}